<div class="app-container">
  @if (!isAdminRoute()) {
    <app-header></app-header>
  }
  
  <main class="main-content">
    <router-outlet></router-outlet>
  </main>

  @if (!isAdminRoute()) {
    <app-footer></app-footer>
  }

  <!-- Global Modal Lead Capture -->
  <app-consultation-modal></app-consultation-modal>
</div>
